<template>
  <div class="n_content">
    <h1>即将查看店铺详细信息…</h1>
    <div class="n_cont">为保证双方信息安全，请先按照提示完成安全验证</div>
    <div class="n_btn" @click="goSlideFg">去验证</div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <slide-verify
          ref="slideblock"
          @again="onAgain"
          @fulfilled="onFulfilled"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          :accuracy="accuracy"
          :slider-text="text"
        ></slide-verify>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: '',
      text: '向右滑',
      // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      accuracy: 8,
      show: false,
    }
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    goSlideFg() {
      this.show = true
    },
    onSuccess(times) {
      this.$router.push({ path: './storeDetail' })
      console.log('验证通过，耗时' + times + '毫秒')
      this.msg = 'login success, 耗时${(times / 1000).toFixed(1)}s'
    },
    onFail() {
      console.log('验证不通过')
      this.msg = ''
    },
    onRefresh() {
      console.log('点击了刷新小图标')
      this.msg = ''
    },
    onFulfilled() {
      console.log('刷新成功啦！')
    },
    onAgain() {
      console.log('检测到非人为操作的哦！')
      this.msg = 'try again'
      // 刷新
      this.$refs.slideblock.reset()
    },
    handleClick() {
      // 父组件直接可以调用刷新方法
      this.$refs.slideblock.reset()
    },
  },
}
</script>
<style scoped>
.n_content .slide-verify {
  margin: 0 auto;
}
</style>
<style scoped lang="scss">
.wrapper {
  margin: 200px auto;
}
.n_content {
  min-height: 100vh;
  background: #f7f8fa;
}
h1 {
  font-size: 48px;
  font-weight: 700;
  color: #323233;
  padding-top: 120px;
  text-align: center;
}
.n_cont {
  font-size: 26px;
  color: #999999;
  text-align: center;
  margin-top: 30px;
}
.n_btn {
  font-size: 32px;
  color: #ffffff;
  width: 686px;
  height: 96px;
  background: #ee0a24;
  border-radius: 48px;
  line-height: 96px;
  text-align: center;
  margin: 70px auto 0;
}
</style>